import lockupZh from "../assets/images/hububble-console-lockup-zh-white.svg";
import lockupEn from "../assets/images/hububble-console-lockup-en-white.svg";

// White "Hububble 簡訊控制台" / "Hububble SMS Console" logo for dark backgrounds
// (login pages and the sidebar), in the interface language.
export const consoleLockup = (language) =>
  language?.startsWith("zh") ? lockupZh : lockupEn;
